import { render, staticRenderFns } from "./WsStaticLocaleUpdate.vue?vue&type=template&id=119af858&"
import script from "./WsStaticLocaleUpdate.vue?vue&type=script&lang=js&"
export * from "./WsStaticLocaleUpdate.vue?vue&type=script&lang=js&"
import style0 from "./WsStaticLocaleUpdate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VForm,VRow})
